// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__HR5FG","paymentContainer":"PaymentPage_paymentContainer__2Cnww"};